// extracted by mini-css-extract-plugin
export default {"container":"aIXfRZfNPxskVnbK1TZf","colon":"HtA62uHphNyFBFECUAaY"};